<template>
  <AiChat :open="visible" ref="aiChat" :title="curIntent && curIntent.index >= 0 ? '编辑意图' : '增加意图'" :quote="quote" @on-close="cancelHandler" @on-insert="onInsert">
		<div class="container">
			<Form :model="formData" ref="form" :label-width="100">
				<FormItem label="标题" prop="name" :rules="{required: true, message: '标题不能为空', trigger: 'blur'}">
					<Input v-model="formData.name" placeholder="" />
				</FormItem>
        <form-item-share-keyword v-if="visible" :formItemProps="{prop: 'ref'}" v-model="formData.ref"/>
				<form-item-keyword
          :formItemProps="{
            prop: 'sentences',
            rules: keywordRules,
          }"
          v-model="formData.sentences"
          @open-ai="() => {
            quote = {
              type: 'aichat.hint',
              name: formData.name,
              workId: 'GENERALIZED_KEYWORDS',
              variables: {
                matching_content: formData.name,
                keywords: (formData.sentences || []).join(',')
              }
            }
            openAi()
          }"
        />
				<FormItem label="按键" prop="digits">
					<Input v-model="formData.digits" placeholder="按键 012345678*#" />
				</FormItem>
				<div class="flex flex-end">
					<Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
					<Button type="primary" @click="submit">确定</Button>
				</div>
			</Form>
		</div>
	</AiChat>
</template>
<script>
import FormItemKeyword from '../../../components/FormItemKeyword.vue';
import FormItemShareKeyword from '../../../components/FormItemShareKeyword.vue';
import AiChat from '@/views/aiChat/index'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    FormItemKeyword,
    FormItemShareKeyword,
    AiChat,
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curIntent: {
      type: Object,
    }
  },
	data() {
    const validateSentences = (rule, value, callback) => {
      if (value.length === 0 && !this.formData.ref.id) {
        callback(new Error('关键词不能为空'));
      } else {
        callback();
      }
    }
		return {
			formData: {
				name: '',
        ref: {
          id: '',
          isPriority: true,
        },
        sentences: [],
        digits: '',
      },
      keywordRules: { validator: validateSentences },
      quote: null,
		}
	},
	watch: {
		curIntent(val) {
			if (!val) return
      const { ref_id, is_ref_priority, ...formData } = cloneDeep(val)
      this.formData = { ...this.formData, ...formData, ref: { id: ref_id, isPriority: is_ref_priority }}
		}
	},
	methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const { ref, ...formData } = this.formData
				this.$emit('onSubmit', {
          ...formData,
          ref_id: ref.id,
          is_ref_priority: true,
          // is_ref_priority: ref.isPriority,
        });
        this.cancelHandler();
      })
    },
		cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
				name: '',
        ref: {
          id: '',
          isPriority: true,
        },
        sentences: [],
        digits: '',
      }
      this.$emit('change', false)
      this.$emit('onCancel')
		},
    openAi() {
			this.$refs.aiChat.sendMessage('泛化')
    },
    onInsert(text) {
      const sentences = this.formData.sentences
      sentences.push(...text.split(/[,，]/))
      this.formData.sentences = [...new Set(sentences)]
    },
  }
}
</script>
<style lang="scss" scoped>
</style>